module.exports = __webpack_public_path__ + "img/memory_300.0e648464.jpg";